import { createFileRoute, redirect } from '@tanstack/react-router';

// The root is the dashboard; whether the person sees it or the login screen is decided by
// the _app layout's session check.
export const Route = createFileRoute('/')({
    beforeLoad: () => {
        throw redirect({ to: '/dashboard' });
    },
});
